import { hudPaths } from '../content';
import { VerifiedOperationsScreen } from '../sections';
import { PageActionBar } from './PageActionBar';

export const VerifiedOperationsPage = () => {
  return (
    <>
      <VerifiedOperationsScreen />
      <PageActionBar activePath={hudPaths.verifiedOperations} ctaLabel="Request Verified Operations Review" />
    </>
  );
};
